export type TableIconStatus = keyof typeof TABLE_ICON_MAP;

export const TABLE_ICON_MAP = {
  default: {
    backgroundColor: 'icon__wrapper--default',
    iconColor: 'icon__icon--default',
    iconName: 'pi pi-user',
  },

  free: {
    backgroundColor: 'icon__wrapper--free',
    iconColor: 'icon__icon--free',
    iconName: 'pi pi-truck',
  },
  on_the_road: {
    backgroundColor: 'icon__wrapper--on_the_road',
    iconColor: 'icon__icon--on_the_road',
    iconName: 'pi pi-truck',
  },

  ready: {
    backgroundColor: 'icon__wrapper--ready',
    iconColor: 'icon__icon--ready',
    iconName: 'pi pi-clock',
  },
  in_progress: {
    backgroundColor: 'icon__wrapper--in_progress',
    iconColor: 'icon__icon--in_progress',
    iconName: 'pi pi-send',
  },
  done: {
    backgroundColor: 'icon__wrapper--done',
    iconColor: 'icon__icon--done',
    iconName: 'pi pi-check-circle',
  },
} as const;
